import { render, staticRenderFns } from "./Keranjang.vue?vue&type=template&id=6d589fa8&"
import script from "./Keranjang.vue?vue&type=script&lang=js&"
export * from "./Keranjang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports